(() => {
    frappe.ready(() => {
        const Orig = webshop.ProductGrid;
        if (!Orig) return;

        class ProductGridPatched extends Orig {
            // Revert: stock availability only (no bulk prices — they move to
            // the bottom row for the compact side-by-side layout, adj3).
            get_stock_availability(item, settings) {
                return Orig.prototype.get_stock_availability.call(this, item, settings) || "";
            }

            // Skip the separate price rendering — price + bulk prices move
            // into the bottom row (adj3: cart left, prices right, same level).
            get_card_body_html(item, title, settings) {
                let body_html = `
                    <div class="card-body text-left card-body-flex" style="width:100%">
                        <div style="margin-top: 0; display: flex;">
                `;
                body_html += `<div class="flex-1 min-width-0">`;
                // Item code + simple UOM view + UOM text on ONE line
                // (PIT-TASK-2027-000337) — was two separate blocks before.
                body_html += webshop.get_item_code_row_html
                    ? webshop.get_item_code_row_html(item, settings) : "";
                body_html += this.get_title(item, title);
                body_html += `</div></div>`;

                if (settings.custom_show_item_group) {
                    body_html += `<div class="product-category" itemprop="name">${ item.item_group_display || item.item_group || '' }</div>`;
                }

                // Price + bulk prices are now in the bottom row (adj3)
                body_html += this.get_stock_availability(item, settings);

                body_html += this.get_bottom_row_html(item, settings);
                body_html += `</div>`;
                return body_html;
            }

            // Bottom row: cart controls (left) + price section (right) + desc
            get_bottom_row_html(item, settings) {
                const cart_row = this.get_cart_action_row(item, settings);
                const desc = item.short_description
                    ? `<div class="ws-short-desc">${ item.short_description }</div>` : ``;

                // Standard price
                // Sold Out (PIT-TASK-2027-000358 adjustment 1): a sold-out
                // item shows NO price in the card — neither the Einzelpreis
                // nor the struck-through MRP.
                let price_html = '';
                if (item.formatted_price && !item.custom_sold_out) {
                    price_html = `<div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">`;
                    price_html += item.formatted_price || '';
                    if (item.formatted_mrp) {
                        price_html += `<small class="striked-price"><s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s></small>`;
                    }
                    price_html += `</div>`;
                }

                // Bulk prices (Staffelpreise) are BACK in the grid cards
                // (PIT-TASK-2027-000376): the adj2 removal
                // (PIT-TASK-2027-000360, commit 012d14a8ab) came back as a
                // customer bug report ("why no bulkprice table shown
                // anymore"). They return as the COMPACT div list
                // (.bulk-prices-list) the server already ships as
                // item.bulk_prices_html (api.py ->
                // render_bulk_price_html_for_items(compact=True)) — NOT the
                // three-column .ws-bulk-price-table that did not fit. That
                // list is right-aligned, wraps, and is height-capped to 3
                // rows by webshop_bulk_prices.scss, so the card keeps its
                // size and never overflows the cart controls; at tablet width
                // the whole .ws-bottom-prices block drops to its own full row
                // (webshop_compact_cards.scss, 768-1024px). The JSON's
                // bulk_prices_html contains the tier rows only — the
                // Einzelpreis stays the .product-price line above.
                // Sold Out (PIT-TASK-2027-000358): a sold-out item gets no
                // Staffelpreis block (the API already sends null for it).
                const bulk_html = item.custom_sold_out ? '' : (item.bulk_prices_html || '');
                const bulk_wrapper = bulk_html ? `<div class="bulk-prices-wrapper">${ bulk_html }</div>` : '';

                const price_section = (price_html || bulk_wrapper)
                    ? `<div class="ws-bottom-prices">${ price_html }${ bulk_wrapper }</div>` : '';

                if (!desc && !cart_row && !price_section) return ``;
                return `<div class="ws-bottom-row">${ cart_row }${ price_section }${ desc }</div>`;
            }
        }
        webshop.ProductGrid = ProductGridPatched;
    });
})();
